import React, { useEffect } from 'react';
import { headers, baseUrl } from './common/credentials';


const port = "10001";
  

  export const getusernameFromServer = (prminputs) => {
    let url = baseUrl + port + "/modules/user_list/";
    return ([headers, url]); 
  }

  export const postuserdataFromServer = (prminputs) => {
    let url = baseUrl + port + "/modules/create_user/";
    return ([headers, url]); 
  }

  export const deleteuserdataFromServer = (prminputs) => {
    let url = baseUrl + port + "/modules/remove_user/";
    return ([headers, url]); 
  }

  